import React, { Fragment } from "react";
import { useSelector, useDispatch } from "react-redux";
import { NavLink, useLocation } from "react-router-dom";
import {
  Grid,
  Divider,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  makeStyles,
  Paper,
} from "@material-ui/core";
import {
  Home as HomeIcon,
  LocalShipping as RemovalsIcon,
  Assignment as ReportsIcon,
  Settings as ProfileIcon,
  Sync as SensorsIcon,
  Eco as EcoIcon,
  People as PeopleIcon,
  LocalShipping as TransIcon,
} from "@material-ui/icons";
import {
  Collapse,
  ListItemSecondaryAction,
  IconButton
} from "@material-ui/core";
import {
  ExpandLess,
  ExpandMore
} from "@material-ui/icons";

import logo from "../../resources/logos/logo-color.png";

import appActions from "../../redux/actions/app";

const useStyles = makeStyles((_theme) => ({
  mobileList: {
    width: "250px",
    height: "100%",
  },
  toolbarLogo: {
    height: "60px",
    margin: "10px",
  },
}));

const sensorItems = [
  {      
    text: "General",
    to: "/sensors",
    icon: <SensorsIcon />,
  },
  { 
    text: 'ALU', 
    to: '/sensors/ALU',
    icon: <SensorsIcon />,
  }, 
  {
    text: 'ALN',
    to: '/sensors/ALN',
    icon: <SensorsIcon />,
  }
];

const items = {
  ADMIN: [
    {
      text: "Home",
      to: "/admin/",
      icon: <HomeIcon />,
    },
    {
      text: "Retiros",
      to: "/removals",
      icon: <RemovalsIcon />,
    },
    {
      text: "Clientes",
      to: "/customers",
      icon: <EcoIcon />,
    },
    {
      text: "Reportes",
      to: "/reports",
      icon: <ReportsIcon />,
    },
    {
      text: "Reportes Excel",
      to: "/excelReports",
      icon: <ReportsIcon />,
    },
    {
      text: "Transportistas",
      to: "/transporters",
      icon: <TransIcon />,
    },
    { // cambios
      text: "Sensores",
      to: "/sensors",
      icon: <SensorsIcon />,
    },
    {
      text: "Plantas",
      to: "/dispositions",
      icon: <EcoIcon />,
    },
    {
      text: "Aprendizaje",
      to: "/learning",
      icon: <ReportsIcon />,
    },
    {
      text: "Usuarios",
      to: "/users",
      icon: <PeopleIcon />,
    },
  ],
  EMPTY: [],
};

export default function Menu() {
  const app = useSelector((state) => state.app);
  const auth = useSelector((state) => state.auth);

  return (
    <Fragment>
      {auth.loged === "LOGED" && app.isMobile && <Mobile />}
      {auth.loged === "LOGED" && !app.isMobile && <Desktop />}
    </Fragment>
  );
}

function Mobile() {
  const classes = useStyles();
  const app = useSelector((state) => state.app);
  const auth = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const switchMenu = (open) => dispatch(appActions.switchMenu(open));
  // ...
  const [openSensors, setOpenSensors] = React.useState(false);
  const handleToggleSensors = () => setOpenSensors(prev => !prev);

  return (
    // ...
    <List>
      {items["ADMIN"].map((element) => {
        if (element.text === "Sensores") {
          return (
            <Fragment key="menu_item_Sensores_mobile">
              <ListItem button onClick={handleToggleSensors}>
                <ListItemIcon>{element.icon}</ListItemIcon>
                <ListItemText>{element.text}</ListItemText>
                <IconButton size="small" onClick={handleToggleSensors}>
                  {openSensors ? <ExpandLess /> : <ExpandMore />}
                </IconButton>
              </ListItem>
              <Collapse in={openSensors} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                  {sensorItems.map((sub) => (
                    <NavLink to={sub.to} key={sub.text} style={{ textDecoration: "none" }}>
                      <ListItem button style={{ paddingLeft: 32 }}>
                        <ListItemText primary={sub.text} />
                      </ListItem>
                    </NavLink>
                  ))}
                </List>
              </Collapse>
            </Fragment>
          );
        }
        // resto de ítems...
      })}
    </List>
  );
}

function Desktop() {
  const location = useLocation();
  const auth = useSelector((state) => state.auth);
  const [openSensors, setOpenSensors] = React.useState(false);

  const handleToggleSensors = () => {
    setOpenSensors(prev => !prev);
  };

  return (
    <div 
      className="sidebar-fixed position-fixed" 
      style={{ 
        paddingTop: "2%", 
        marginLeft: 12, 
      }}
      >
      <Paper>
        <List>
          {items["ADMIN"].map((element) => {
            
            if (element.text === "Sensores") {
              return (
                <Fragment key="menu_item_Sensores">
                  <ListItem button onClick={handleToggleSensors}>
                    <ListItemIcon>{element.icon}</ListItemIcon>
                    <ListItemText>{element.text}</ListItemText>
                    <ListItemSecondaryAction>
                      <IconButton edge="end" size="small" onClick={handleToggleSensors}>
                        {openSensors ? <ExpandLess /> : <ExpandMore />}
                      </IconButton>
                    </ListItemSecondaryAction>
                  </ListItem>
                  <Collapse in={openSensors} timeout="auto" unmountOnExit>
                    <List component="div" disablePadding>
                      {sensorItems.map((sub) => (
                        <NavLink 
                          to={sub.to} 
                          key={sub.text} 
                          style={{ textDecoration: "none" }}>
                          <ListItem button selected={location.pathname === sub.to} style={{ paddingLeft: 32 }}>
                            <ListItemIcon>{sub.icon}</ListItemIcon>
                            <ListItemText primary={sub.text} />
                          </ListItem>
                        </NavLink>
                      ))}
                    </List>
                  </Collapse>
                </Fragment>
              );
            }
            // resto de ítems
            return (
              <NavLink 
                exact={true} 
                to={element.to} 
                key={"menu_item_" + element.text}
                strict
                style={{ 
                  textDecoration: "none", 
                  }}>
                <ListItem selected={location.pathname === element.to}>
                  <ListItemIcon>{element.icon}</ListItemIcon>
                  <ListItemText>{element.text}</ListItemText>
                </ListItem>
              </NavLink>
            );
          })}
        </List>
      </Paper>
    </div>
  );
}
